import type { FaireProductEntity } from "../../entity_types/product";

export const p_pv2wyzdtt5: FaireProductEntity = {
  token: "p_pv2wyzdtt5",
  type: "product",
  name: "Custom Comfort Color Graphic Tee",
  brandToken: "b_ep6gjj3v9q",
  brandName: "Branded By Barta",
  imageUrl:
    "https://cdn.faire.com/fastly/c06aa1c264eb0543786da3700ddd0c39b6e33a5a3207b8e0171f6a90097c42e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d957ebd08f51cb2d4009b9be8cd28d94d797c29283b167bd2601abcac96f9482.png",
    "https://cdn.faire.com/fastly/6c741033da5f2c854151839e30b08d776245b8744cdf8be5b0e6186d8180915b.png",
    "https://cdn.faire.com/fastly/851ca53c82379a0b23ed68206092b9e105de6cf3125fd43e37364260564a5524.png",
    "https://cdn.faire.com/fastly/c4990f863af69c38aa4671c5bbb9cfc9594122706296d621a816852557ba6f3c.png",
    "https://cdn.faire.com/fastly/48136cd751c30b924882b639c7af0184b44f55eef5e4e37d527abf4df9eb7ee7.png",
    "https://cdn.faire.com/fastly/329624aaeb64f10599b9a77b1ff6f71f3c120c79e1be6f862d902a535a48ffd5.png",
    "https://cdn.faire.com/fastly/619c634a26a0229dac66ba0e9383fe01c3dffcc168565ed5f48f550a5fc60e53.png",
  ],
  priceDollars: 15,
  description:
    "Branded By Barta creates fun, trendy graphic tees designed with boutique shoppers in mind. Our styles mix western charm, everyday humor, sports season favorites, and faith-inspired designs that customers love to grab off the rack.\n\n**This is for a custom option*** Customize with any print, please contact us via message or email at [redacted-email] for questions. \n\nWe focus on soft, high-quality tees and graphics that stand out, making them easy sellers for storefronts, pop-ups, markets, and online boutiques.\n\n✨ Boutique-friendly styles that follow current trends\n✨ Soft retail-fit tees your customers will reach for again and again\n✨ New designs added regularly to keep your racks fresh\n\nThank you for supporting our small business and allowing Branded By Barta designs to be part of your boutique collection. We truly appreciate every order! 🤍\n\nMade IN HOUSE - dtf transfers or sublimation transfers are printed in house.\nTurn Around Time is 7-10 Business Days! Shipping not included.  ",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:48.444Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
